// extracted by mini-css-extract-plugin
export default {"header":"style_header__HIR0l","headerWrap":"style_headerWrap__yo1fx","headerLogo":"style_headerLogo__SS1c5","virtuLogo":"style_virtuLogo__LJoNu","headline":"style_headline__Ruj5F"};